document.addEventListener('DOMContentLoaded', function() {
    const surveyWrapper = document.getElementById('jichica-survey-wrapper');
    if (!surveyWrapper) return;

    // HTMLの属性から必要なデータを一括取得（変数定義の場所を確実に固定）
    const postId = surveyWrapper.getAttribute('data-post-id');
    const pattern = surveyWrapper.getAttribute('data-pattern');
    const nonce = surveyWrapper.getAttribute('data-nonce');
    const restNonce = surveyWrapper.getAttribute('data-rest-nonce'); // ★ここが正しく定義されているか確認
    const apiUrl = surveyWrapper.getAttribute('data-api-url');

    const hpField = document.getElementById('jichica_hp_field');
    const buttonsContainer = document.getElementById('jichica-survey-buttons');
    const messageArea = document.getElementById('jichica-survey-message');
    const storageKey = 'jichica_voted_post_' + postId;

    // 1. 投票済みチェック (LocalStorageから前回選択した値を取得)
    const savedChoice = localStorage.getItem(storageKey);
    if (savedChoice) {
        showFinalState(savedChoice);
        return;
    }

    // 2. 投票ボタンのクリックイベント
    const voteButtons = surveyWrapper.querySelectorAll('.jichica-btn-vote');
    voteButtons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();

            // 連打防止のためすべてのボタンを無効化
            voteButtons.forEach(b => b.disabled = true);

            const choice = this.getAttribute('data-choice');
            // const hpValue = hpField ? hpField.value : '';
            // ▽ 以下に差し替え：直接HTML要素から値を取得する
            const hpElement = document.getElementById('jichica_hp_field');
            const hpValue = hpElement ? hpElement.value : '';

            // 送信データの準備（前回投票した選択肢があれば取得）
            const oldChoice = localStorage.getItem(storageKey) || '';

            const formData = new FormData();
            formData.append('action', 'jichica_survey_vote');
            formData.append('post_id', postId);
            formData.append('pattern', pattern);
            formData.append('choice', choice);
            formData.append('old_choice', oldChoice); // ★追加：減算処理用
            formData.append('nonce', nonce);
            formData.append('jichica_hp_field', hpValue);

            // Fetch APIでバックエンドの窓口へ送信
            fetch(apiUrl, {
                method: 'POST',
                // headers: {
                //     'X-WP-Nonce': restNonce // ★ここで上のrestNonceを確実に使用する
                // },
                body: formData
            })
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(function(data) {
                if (data.success) {
                    // 投票成功：選んだ選択肢(choice)を記憶させて画面更新
                    localStorage.setItem(storageKey, choice);
                    showVotedState(choice);

                    // // PHP側の管理者メッセージがあればそれを表示、無ければ標準メッセージ
                    // const successMsg = data.message ? data.message : '投票が完了しました！';
                    // showVotedState(successMsg);
                } else {
                    // エラー処理
                    alert('エラーが発生しました: ' + data.message);
                    voteButtons.forEach(b => b.disabled = false);
                }
            })
            .catch(function(error) {
                console.error('Error:', error);
                alert('通信エラーが発生しました。ページを更新して再度お試しください。');
                voteButtons.forEach(b => b.disabled = false);
            });
        });
    });

    // 投票直後の表示（その場での変更ボタン付き）
    function showVotedState(currentChoice) {
        if (buttonsContainer) buttonsContainer.style.display = 'none';
        if (messageArea) {
            const choiceLabel = getChoiceLabel(currentChoice);
            messageArea.innerHTML = `
                <span>「${choiceLabel}」で投票しました。</span>
                <button type="button" id="jichica-survey-revote" style="margin-left:8px; text-decoration:underline; background:none; border:none; color:#0056b3; cursor:pointer; font-size:13px;">[選択を変更する]</button>
            `;
            messageArea.style.display = 'block';

            // 「選択を変更する」をクリックしたらボタンを再表示（この時点ではイベントが生きているので動く）
            const revoteBtn = document.getElementById('jichica-survey-revote');
            if (revoteBtn) {
                revoteBtn.addEventListener('click', function() {
                    messageArea.style.display = 'none';
                    buttonsContainer.style.display = 'flex';
                    voteButtons.forEach(b => b.disabled = false);
                });
            }
        }
    }

    // ページ再訪問時の表示（変更不可・結果のみ）
    function showFinalState(currentChoice) {
        if (buttonsContainer) buttonsContainer.style.display = 'none';
        if (messageArea) {
            const choiceLabel = getChoiceLabel(currentChoice);
            messageArea.textContent = `「${choiceLabel}」で受付済みです。ご協力ありがとうございました。`;
            messageArea.style.display = 'block';
        }
    }

    // 日本語ラベル変換ヘルパー
    function getChoiceLabel(currentChoice) {
        const labelMap = {
            'pattern_a': { 'yes': '賛成', 'no': '反対' },
            'pattern_b': { 'yes': '参加する', 'no': '参加しない' },
            'pattern_c': { 'good': '良い', 'normal': '普通', 'bad': '悪い' }
        };
        return (labelMap[pattern] && labelMap[pattern][currentChoice]) ? labelMap[pattern][currentChoice] : currentChoice;
    }
});